/**
 * Cấu hình icon và label tiếng Việt cho các filter
 */

interface IFilterDisplayConfig {
  icon?: string
  labelVi?: string
  type?: 'checkbox' | 'size' | 'color' | 'price'
}

/**
 * Xác định loại filter dựa vào attribute_code và label
 */
export const determineFilterType = (
  attributeCode: string,
  label: string
): 'checkbox' | 'size' | 'color' | 'price' => {
  // Auto-detect based on attribute_code hoặc label
  const lowerCode = attributeCode.toLowerCase()
  const lowerLabel = label.toLowerCase()

  if (lowerCode === 'price' || lowerLabel.includes('price') || lowerLabel.includes('giá')) {
    return 'price'
  }

  if (lowerCode === 'color' || lowerLabel.includes('color') || lowerLabel.includes('màu')) {
    return 'color'
  }

  if (lowerCode === 'size' || lowerLabel.includes('size')) {
    return 'size'
  }

  // Default: checkbox
  return 'checkbox'
}
